import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_EE: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'Meestele',
  components_header_media_2: 'Naistele',
  components_header_media_multi_content_2: 'Jooga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Treeni targemini, tunne end paremini.',
  hero_button_text: 'Alusta kohe',
  components_ressources_subheader_text: 'Juhendid ja näpunäited',
  components_ressources_span_text: 'See ühendab jooga maise lähenemise, Pilatese kontrollitud täpsuse ja jõutreeningu dünaamilise väljakutse, et toetada mitmekülgset ja tervislikku eluviisi.',
  components_ressources_card_1_title: 'Jooga näpunäited',
  components_ressources_card_1_text: 'Kiirjuhend parema tasakaalu, hingamise ja hingamisvoogude parandamiseks.',
  components_ressources_card_2_title: 'Pilatese näpunäited',
  components_ressources_card_2_text: 'Lihtsad näpunäited kerelihaste tugevdamiseks ja kontrolli parandamiseks.',
  components_notes_and_google_title_1: 'Tugevdamine',
  components_notes_and_google_title_2: 'Jooga rahu',
  components_notes_and_google_title_3: 'Pilatese põhitõed',
  media_content_section_multi_1_subheader_text: 'Treeningvideod',
  media_content_section_multi_2_subheader_text: 'Joogavideod',
  media_content_section_multi_3_subheader_text: 'Pilatese videod',
  text_media_1: 'Mehed',
  text_media_2: 'Naised',
  page_media_content_menu_biceps: 'Biitseps',
  page_media_content_menu_triceps: 'Triitseps',
  page_media_content_menu_back: 'Tagasi',
  page_media_content_menu_chest: 'Rindkere',
  page_media_content_menu_legs: 'Jalad',
  page_media_content_menu_shoulders: 'Õlad',
  page_media_content_menu_abdominals: 'Kõhulihased',
  components_text1_subheader_text: 'Tervislik toitumine aktiivse elu jaoks',
  components_text1_span_text: 'Tervislikud retseptid, mis toetavad teie treeningut ja parandavad teie heaolu.',
  components_footer_text: 'Tugevda oma keha, tasakaalusta meelt ja liigu tähendusrikkalt – sinu koht jõusaali, jooga ja pilatese jaoks.',
};